<template>
    <div class="page-content">
        <div class="banner__image"></div>

        <div class="banner">
            <img src="assets/images/logo_white.svg" alt="PlanIt Logo" />
            <p>Share amazing places with people around the world.</p>

            <form class="search">
                <input type="search" placeholder="Where do you want to go?" />
                <button type="submit" class="main-btn">Search Trips</button>
            </form>
        </div>

        <div class="top-destinations">
            <h2>Top destinations to visit</h2>
            <p>We help you plan the best getaway trip.</p>

            <div class="destination-list">
                <DestinationItem
                    v-for="n in 6"
                    v-bind:key="n"
                    v-bind:hasComments="false"></DestinationItem>
            </div>

            <button class="main-btn">Discover More</button>
        </div>

        <div class="section featured-itineraries">
            <h2>Featured Itineraries</h2>
            <p>We keep a vitrual diary of your trips for you to share and reminisce.</p>

            <div class="itineraries-list">
                <ItineraryItem v-for="n in 6" v-bind:key="n"></ItineraryItem>
            </div>
        </div>

        <div class="section how-it-works">
            <h2>How it Works</h2>

            <div class="directions-list">
                <div class="direction-item">
                    <div class="direction__image">
                        <img src="assets/images/strategy.png" alt="Step 1 Image" />
                    </div>

                    <div class="direction__title">Step 1</div>
                    <p>Create your trip using our <span>itinerary planner</span></p>
                </div>
                <div class="direction-item">
                    <div class="direction__image">
                        <img src="assets/images/menu.png" alt="Step 2 Image" />
                    </div>

                    <div class="direction__title">Step 2</div>
                    <p><span>Save</span> it and <span>download</span> the plan to your phone</p>
                </div>
                <div class="direction-item">
                    <div class="direction__image">
                        <img src="assets/images/virtual-reality.png" alt="Step 3 Image" />
                    </div>

                    <div class="direction__title">Step 3</div>
                    <p><span>Navigate</span> through your entire trip, one place at a time</p>
                </div>
            </div>

            <button class="main-btn">Create a New Itinerary</button>
        </div>

        <div class="section logos">
            <div class="logos-list">
                <div class="logo-item">
                    <img src="assets/images/logos/logo1.png" alt="Logo Name" />
                </div>
                <div class="logo-item">
                    <img src="assets/images/logos/logo2.png" alt="Logo Name" />
                </div>
                <div class="logo-item">
                    <img src="assets/images/logos/logo3.png" alt="Logo Name" />
                </div>
                <div class="logo-item">
                    <img src="assets/images/logos/logo4.png" alt="Logo Name" />
                </div>
                <div class="logo-item">
                    <img src="assets/images/logos/logo5.png" alt="Logo Name" />
                </div>
            </div>
        </div>

        <div class="section testimonials">
            <h2>Testimonials from our users</h2>

            <div class="testimonials-list">
                <TestimonialItem v-for="n in 3" v-bind:key="n"></TestimonialItem>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Home',
        components: {
            DestinationItem: require('./destinationItem').default,
            ItineraryItem: require('./itineraryItem').default,
            TestimonialItem: require('./testimonialItem').default
        },
        beforeCreate: function() {
            let body = document.querySelector('body')
            body.dataset.page = 'home'
        }
    }
</script>

<style scoped lang="scss">
    // banner styles
    .banner__image {
        background: url('/assets/images/banner.png') no-repeat center;
        background-size: cover;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: calc(100vw / 1440 * 671);

        @media all and (max-width: 970px) {
            height: 80vh;
        }

        @media all and (max-width: $breakpoint) {
            min-height: calc(100vw / 1440 * 671 * 2);
        }
    }

    .banner__image::after {
        content: "";
        background-color: rgba(#000, 0.2121);
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }


    .banner {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 100%;
        z-index: 1;

        @media all and (max-width: 970px) {
            height: auto;
        }

        @media all and (min-width: $breakpoint + 1) {
            padding: 104px 20px 40px;
        }

        @media all and (max-width: $breakpoint) {
            padding: 80px 0 30px;
            height: auto;
        }
    }


    .banner img {
        display: block;

        @media all and (min-width: $breakpoint + 1) {
            width: 169px;
            height: 84px;
        }

        @media all and (max-width: $breakpoint) {
            width: 90px;
            height: auto;
        }
    }


    .banner p {
        text-align: center;
        font-weight: $book;
        color: #FFF;

        @media all and (min-width: $breakpoint + 1) {
            margin-top: 2px;
            font-size: 24px;
        }

        @media all and (max-width: $breakpoint) {
            margin-top: 5px;
            padding: 0 15px;
            font-size: 16px;
        }
    }


    .banner button {

        @media (min-width: $breakpoint + 1) and (max-width: 970px) {
            margin-left: 20px;
        }
    }


    .top-destinations {
        background-color: #FFF;
        position: relative;
        margin: 0 auto;
        padding: 75px 0;
        max-width: 940px;
        box-shadow: 0 2px 4px rgba($gray, 0.5);
        z-index: 1;

        @media all and (max-width: 970px) {
            margin: 20px 10px 0;
        }

        @media all and (max-width: $breakpoint) {
            padding: 20px 15px;
        }
    }

    .top-destinations .search {
        margin-top: 27px;
    }

    .top-destinations > .main-btn {
        display: block;
        margin: 41px auto 0;

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
            width: 100%;
        }
    }
</style>
